import { createMatchSelector } from 'connected-react-router';
import { connect } from 'react-redux';
import { path, pipe } from 'ramda';

import PatientHistory from 'components/TransmissionReport/PatientHistory';
import {
  getFormattedPriorArtialArrhythmia,
  getFormattedCardiacRiskFactors,
  getPriorVentricularArrhythmia,
  getPriorCurrentTreatment,
  getFormattedEjectionFraction,
} from 'containers/ArrhythmiaHistoryTable/formatters';

import { getPatientDeviceType, getPatientYO, getPatientGender } from 'store/selectors/patientsData';
import {
  getPatientHeartDiseaseString,
  getIcdIndDisplay,
  getNyhaClassDisplay,
  getCardiacRisksActive,
  getFormattedMedications,
  getFrailityScore,
  getHospitalizations,
  getQuestionnaireResponseBaselineBloodwork,
  getEfValue,
  getEfDate,
  getEfMethod,
  getPacemakerDependent,
  getPriorVentricularArrhythmiaRecent,
  getTreatmentType,
  getAntiarrhythmicMedication,
} from 'store/selectors/questionnaireResponses';

const mapStateToProps = state => {
  const patientId = pipe(
    createMatchSelector('/patient/:id'),
    path(['params', 'id']),
  )(state);

  return {
    birthDate: getPatientYO(patientId)(state),
    cardiacRiskFactors: getFormattedCardiacRiskFactors(getCardiacRisksActive(patientId)(state)),
    ejectionFractionMostRecent: getFormattedEjectionFraction({
      value: getEfValue(patientId)(state),
      date: getEfDate(patientId)(state),
      method: getEfMethod(patientId)(state),
    }),
    pacemakerDependent: getPacemakerDependent(patientId)(state),
    deviceType: getPatientDeviceType(patientId)(state),
    heartDisease: getPatientHeartDiseaseString(patientId)(state),
    icdInd: getIcdIndDisplay(patientId)(state),
    nyhaClass: getNyhaClassDisplay(patientId)(state),
    sex: getPatientGender(patientId)(state),
    priorArtialArrhythmia: getFormattedPriorArtialArrhythmia(state, patientId),
    priorVentricularArrhythmia: getPriorVentricularArrhythmia(state, patientId),
    priorTreatmentDetection: getPriorVentricularArrhythmiaRecent(patientId)(state),
    treatmentType: getTreatmentType(patientId)(state),
    treatment: getPriorCurrentTreatment(state, patientId),
    AntiarrhythmicMedication: getAntiarrhythmicMedication(patientId)(state),
    medications: getFormattedMedications(patientId)(state),
    frailtyScore: getFrailityScore(patientId)(state),
    hospitalizations: getHospitalizations(patientId)(state),
    baselineBloodwork: getQuestionnaireResponseBaselineBloodwork(patientId, true)(state),
  };
};

export default connect(mapStateToProps)(PatientHistory);
